export default function createNotificationData(firebase, user) {
	return {
		timestamp: firebase.firestore.FieldValue.serverTimestamp(),
		seenBy: user ? [user.id] : [],
	};
}
